import React, { Fragment } from 'react';

import { Alert, Text, Input, Box, Button } from 'components';

const RequestResetForm = props => {
  const { disabled, form, errors, success, onChange, onSubmit } = props;
  const { email } = form;

  return (
    <Fragment>
      {errors.reset && (
        <Alert rounded type="danger">
          <Text mb="0">{errors.reset}</Text>
        </Alert>
      )}

      {success.reset && (
        <Alert rounded type="success">
          <Text mb="0">{success.reset}</Text>
        </Alert>
      )}

      <Box className="hero-form">
        <form onSubmit={onSubmit} name="submit">
          <Input
            name="email"
            label="Email"
            type="email"
            value={email}
            error={errors && errors.email}
            onChange={onChange}
          />
          <Box my="5">
            <Button type="submit" disabled={disabled} large secondary>
              Request Password Reset
            </Button>
          </Box>
        </form>
      </Box>
    </Fragment>
  );
};

export default RequestResetForm;
